<template>
	<button
		type="button"
		class="one-sidebar-toggle"
		:class="{ 'is-open': isOpen, 'is-closed': !isOpen }"
		:title="toggleTitle"
		:aria-label="toggleTitle"
		@click="handleToggleClick"
	>
		<Icon
			class="one-sidebar-toggle__icon"
			icon-name="right-arrow-small"
			size="md"
		/>
	</button>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'OneSidebarToggle',
	components: { Icon },
	props:      {
		isOpen: {
			type:     Boolean,
			required: true,
		},
	},
	computed: {
		toggleTitle() {
			return this.$Helpers.ucfirst(this.$I18n.trans(`commons.${this.isOpen ? 'hide' : 'show'}`));
		},
	},
	methods: {
		handleToggleClick(event) {
			this.$emit('toggle');
			event.currentTarget.blur();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.one-sidebar-toggle {
	position: absolute;
	top: calc(var(--one-panel-h-padding) + 19px);
	right: var(--one-panel-h-padding);
	z-index: 2;
	display: none;
	width: $sp4-5;
	height: $sp4-5;
	min-width: 0;
	border: 0;
	border-radius: 50%;
	background-color: var(--color-white);
	color: var(--color-black);
	cursor: pointer;
	align-items: center;
	justify-content: center;
	padding: 0;
	transform: translateX(50%);

	@include size(md-up) {
		display: inline-flex;
	}

	body.-t-light & {
		background-color: var(--color-grey-300);
		color: var(--color-white);

		&:focus,
		&:hover {
			background-color: var(--color-grey-500);
		}

	}

	&.is-open {
		right: calc(var(--one-panel-h-padding) + var(--one-side-panel-width) + (var(--one-panel-gap) / 2));
	}

	&.is-closed {
		.one-sidebar-toggle__icon {
			transform: rotate(180deg);
		}
	}

	&:focus,
	&:hover {
		background-color: var(--color-grey-300);
		color: var(--color-grey-900);
	}
}
</style>
